import React, {useEffect,useState,useContext,useRef} from 'react'
import { GlobalContext } from '../contexts/GlobalContext';
import { useParams} from 'react-router-dom';
import EditUser from './EditUser';
import {PiLockKeyOpen ,PiPencilSimple, PiIdentificationCardLight, PiUserLight, PiShapesLight, PiUsersThreeLight, PiUsersFourLight, PiClockLight, PiIdentificationBadgeLight, PiGenderIntersexLight, PiClockUserLight, PiGlobeLight, PiEnvelopeLight, PiPhoneLight, PiMapPinAreaLight, PiMailboxLight, PiMapPinLineLight, PiCertificateLight, PiBuildingLight, PiStethoscopeLight, PiHospitalLight, PiDownloadSimple } from 'react-icons/pi';
import ResetPassword from './ResetPassword';
import client from '../client';
import LoadingIcons from 'react-loading-icons';
import { Detail,SectionContainer,Sections,Section,Scrollable,Header,createDialog } from 'coaz-ui';
import SetPassword from './SetPassword';


const User = () => {
    const {version,setVersion} = useContext(GlobalContext);
    const [user,setUser] = useState(null);
    const [expiryDate,setExpiryDate] = useState(null);
    const [buttons,setButtons] = useState([]);
    const [loading,setLoading] = useState(true);
    const {userId} = useParams();
    const containerRef = useRef(null);
    const currentRef = useRef(null);
    const userRef = useRef(null);

    const {request,getCurrent,download} = client;

    const onEdit = async (e) => {
        e.preventDefault();
        if(!currentRef.current) return;
        let self = false;
        if(!userId || userId === currentRef.current.user.ref.id) {
            self = true
        }
        createDialog({
            title:"Edit User",
            params:{id:self?currentRef.current.user.ref.id:userId},
            Component:EditUser,
            version:version,
            setVersion:setVersion
        })
    }

    const onSetPassword = (e) => {
        if(!userRef.current) return;
        createDialog({
            title:"Set Password",
            params:{username:userRef.current.name},
            Component:SetPassword,
            version:version,
            setVersion:setVersion
        })
    }

    const onResetPassword = (e) => {
        if(!userRef.current) return;
        createDialog({
            title:"Reset Password",
            params:{username:userRef.current.name},
            Component:ResetPassword,
            version:version,
            setVersion:setVersion
        })
    }

    const onDownLoadCertificate = (e) => {
        download('users/certificate')
        .then((response) => {
            if(response && response.data instanceof Blob) {
                const contentDisposition = response.headers["content-disposition"];
                let fileName = "membership_certificate.pdf";

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (match) {
                        fileName = match[1];
                    }
                }

                const href = URL.createObjectURL(response.data);
                const link = document.createElement("a");
                link.href = href;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            }
        })
        .catch((error) => {
            console.log(error)
        })
    }

    const load = async () => {
        setLoading(true);
        let curr = await getCurrent();

        if(!curr) {
            setLoading(false);
            return
        }
        currentRef.current = curr;
        let readUser = curr.authorities.find((auth) => {return auth.authority === 'USER:READ'});
        let updateUser = curr.authorities.find((auth) => {return auth.authority === 'USER:UPDATE'});
        let usr = null;
        let slf = false;
        if(readUser && userId && userId !== curr.user.ref.id) {
            await request('GET',`users/${userId}`)
            .then(async (response) => {
                if(response && response.ref) {
                    usr = response;
                }
            })
            .catch(() => {})
        } else {
            usr = curr.user;
            slf = true;
        }
        if(usr) {
            usr.dateOfBirth = usr.dateOfBirth?new Date(usr.dateOfBirth):new Date();
            usr.createdDate = usr.createdDate?new Date(usr.createdDate):new Date();
            usr.lastModifiedDate = usr.lastModifiedDate?new Date(usr.lastModifiedDate):new Date();

            setUser(usr);
            userRef.current = usr;

            if(usr.userType && usr.userType.ref && usr.userType.ref.value) {
                await request('GET','user-types/expiry-date',null,{
                    userId:usr.ref.id,
                    tariffableReference:usr.userType.ref.value
                })
                .then((response) => {
                    if(response && response !== '') {
                        setExpiryDate(new Date(response));
                    }
                })
                .catch((error)=>{
                    console.log(error)
                })
            }
        }
        let btns = [];
        if(usr && (updateUser || slf )) {
            btns.push(
                {
                    Icon:PiPencilSimple,
                    name:'Edit',
                    handler:onEdit
                }
            )
        }
        if(usr && slf) {
            btns.push(
                {
                    Icon:PiLockKeyOpen,
                    name:'Set Password',
                    handler:onSetPassword
                }
            )
            btns.push(
                {
                    Icon:PiDownloadSimple,
                    name:'Download Certificate',
                    handler:onDownLoadCertificate
                }
            )
        }
        if(usr && !slf) {
            btns.push(
                {
                    Icon:PiLockKeyOpen,
                    name:'Reset Password',
                    handler:onResetPassword
                }
            )
        }
        setButtons(btns);
        setLoading(false)
    }

    useEffect(() => {
        load();
    },[userId,version])

    if(user) {
        return (
            <div className='flex flex-col w-full h-full space-y-4 overflow-hidden'>
                <Header Icon={PiUserLight} text='My Profile' buttons={buttons}/>
                {loading?
                <div className='flex items-center justify-center w-full h-full'>
                    <LoadingIcons.SpinningCircles width={64} height={64} fill="rgb(1,175,240)"/>
                </div>:
                <Scrollable vertical={true}>
                    <div ref={containerRef} className='flex flex-col w-full space-y-4'>
                        <SectionContainer>
                            <div className='flex flex-col items-center justify-center p-4 overflow-hidden w-fit h-fit shrink-0'>
                                <div className='flex flex-col items-center w-full overflow-hidden shrink-0 '>
                                    <div className='flex justify-center items-center text-6xl mb-4 text-white w-40 h-40 rounded-full bg-[rgb(0,175,240)] shadow-xl'>
                                        <span>{user.firstname.charAt(0).toUpperCase()+user.lastname.charAt(0).toUpperCase()}</span>
                                    </div>
                                    <span className='text-[rgb(68,71,79)] font-helveticaNeueMedium text-3xl text-nowrap capitalize'>{`${user.firstname.toLowerCase()} ${user.lastname.toLowerCase()}`}</span>
                                    <span className='text-[rgb(68,71,79)] text-nowrap lowercase'>{user.name}</span>
                                </div>
                            </div>
                            <Sections>
                                <Section name='System Details'>
                                    <Detail Icon={PiUserLight} label='User ID' value={user.ref.id}/>
                                    <Detail Icon={PiUserLight} label='COAZ Number' value={user.userCode}/>
                                    <Detail Icon={PiUserLight} label='Username' value={user.name}/>
                                    <Detail Icon={PiUsersThreeLight} label='User Type' value={user.userType?user.userType.name:''} capitalize={true}/>
                                    <Detail Icon={PiUsersFourLight} label='User Group' value={user.userGroup?user.userGroup.name:'N/A'}/>
                                    <Detail Icon={PiClockLight} label='Expiry date' value={expiryDate?expiryDate.toLocaleString('default', { month: 'long' })+' '+expiryDate.getDate()+', '+expiryDate.getFullYear()+' '+expiryDate.toLocaleTimeString('en-US'):'N/A'}/>
                                    <Detail Icon={PiClockLight} label='Created date' value={user.createdDate && user.createdDate !== ''?user.createdDate.toLocaleString('default', { month: 'long' })+' '+user.createdDate.getDate()+', '+user.createdDate.getFullYear()+' '+user.createdDate.toLocaleTimeString('en-US'):'N/A'}/>
                                    <Detail Icon={PiClockLight} label='Last modified date' value={user.lastModifiedDate && user.lastModifiedDate !== ''?user.lastModifiedDate.toLocaleString('default', { month: 'long' })+' '+user.lastModifiedDate.getDate()+', '+user.lastModifiedDate.getFullYear()+' '+user.lastModifiedDate.toLocaleTimeString('en-US'):'N/A'}/>
                                </Section>
                                <Section name='Personal Details'>
                                    <Detail Icon={PiIdentificationBadgeLight} label='Firstname' value={user.firstname} capitalize={true}/>
                                    <Detail Icon={PiIdentificationBadgeLight} label='Lastname' value={user.lastname} capitalize={true}/>
                                    <Detail Icon={PiIdentificationBadgeLight} label='Middle' value={user.middlename && user.middlename !== ''?user.middlename:'N/A'} capitalize={true}/>
                                    <Detail Icon={PiGenderIntersexLight} label='Sex' value={user.sex && user.sex !== ''?user.sex:'N/A'}/>
                                    <Detail Icon={PiClockUserLight} label='Date of Birth' value={user.dateOfBirth && user.dateOfBirth !== ''?user.dateOfBirth.toLocaleString('default', { month: 'long' })+' '+user.dateOfBirth.getDate()+', '+user.dateOfBirth.getFullYear():'N/A'}/>
                                    <Detail Icon={PiIdentificationCardLight} label='Id Number' value={user.idNumber}/>
                                    <Detail Icon={PiIdentificationCardLight} label='ID Type' value={user.idType && user.idType !== ''? user.idType:'N/A'}/>
                                    <Detail Icon={PiGlobeLight} label='Nationality' value={user.nationality && user.nationality !== ''?user.nationality:'N/A'}/>
                                </Section>
                            </Sections>
                        </SectionContainer>
                        <SectionContainer>
                            <Sections>
                                <Section name='Contact Details'>
                                    <Detail Icon={PiEnvelopeLight} label='Email' value={user.email}/>
                                    <Detail Icon={PiPhoneLight} label='Phone 1' value={user.phone1 && user.phone1 !== ''?user.phone1:'N/A'}/>
                                    <Detail Icon={PiPhoneLight} label='Phone 2' value={user.phone2 && user.phone2 !== ''?user.phone2:'N/A'}/>
                                    <Detail Icon={PiMapPinLineLight} label='Physical Address' value={user.physicalAddress && user.physicalAddress !== ''?user.physicalAddress:'N/A'} capitalize={true}/>
                                    <Detail Icon={PiMailboxLight} label='Postal Address' value={user.postalAddress && user.postalAddress !== ''?user.postalAddress:'N/A'} capitalize={true}/>
                                    <Detail Icon={PiMapPinAreaLight} label='District' value={user.district?user.district.name:'N/A'}/>
                                    <Detail Icon={PiMapPinAreaLight} label='Province' value={user.district && user.district.province?user.district.province:'N/A'}/>
                                </Section>
                                <Section name='Professional Details'>
                                    <Detail Icon={PiCertificateLight} label='Qualification' value={user.program && user.program !== ''?user.program:'N/A'}/>
                                    <Detail Icon={PiBuildingLight} label='Institution' value={user.institution && user.institution !== ''?user.institution:'N/A'}/>
                                    <Detail Icon={PiShapesLight} label='Professional Category' value={user.professionalCategory && user.professionalCategory !== ''?user.professionalCategory:'N/A'}/>
                                    <Detail Icon={PiStethoscopeLight} label='Employed' value={user.employed?'Yes':'No'}/>
                                    <Detail Icon={PiBuildingLight} label='Employer' value={user.employer && user.employer !== ''?user.employer:'N/A'}/>
                                    <Detail Icon={PiUserLight} label='Employee Id' value={user.employeeId && user.employeeId !== ''?user.employeeId:'N/A'}/>
                                    <Detail Icon={PiHospitalLight} label='Organizational Unit' value={user.organizationalUnit && user.organizationalUnit !== ''?user.organizationalUnit:'N/A'}/>
                                    <Detail Icon={PiHospitalLight} label='Current Position' value={user.currentPosition && user.currentPosition !== ''?user.currentPosition:'N/A'}/>
                                    <Detail Icon={PiHospitalLight} label='Facility' value={user.facility && user.facility !== ''?user.facility:'N/A'}/>
                                </Section>
                            </Sections>
                        </SectionContainer>
                    </div>
                </Scrollable>
                }
            </div>
        )
    } else {
        return (<></>)
    }
}

export default User